@if (!character.absent && settingsManager.settings.summons) {
  <div class="summons-container" [ngClass]="{ empty: summonCount === 0, off: off }">
    <span class="spacer"></span>
    @if (settingsManager.settings.entitiesMenu) {
      <span
        class="entities-menu"
        [ngClass]="{ empty: summonCount === 0, disabled: summonCount < 2 }"
        [entityAnimation]="summonCount === 0"
        (click)="openEntitiesMenu($event)"
      >
        <img class="icon" [src]="character.iconUrl" />
        <img class="menu" src="./assets/images/up.svg" />
      </span>
    }
    <div class="summons">
      @for (summon of summons | trackUUID; track summon._trackUUID) {
        <ghs-standee [figure]="character" [entity]="summon"> </ghs-standee>
      }
    </div>
  </div>
}

<div
  class="character"
  [style.--ghs-character-color]="character.color"
  [ngClass]="{
    off: off || character.absent,
    denied: !gameManager.stateManager.characterPermissions[character.name + '|' + character.edition],
    absent: character.absent,
    dimmed:
      ((bb || settingsManager.settings.characterSheet) &&
        settingsManager.settings.characterAttackModifierDeck &&
        character.attackModifierDeckVisible &&
        !settingsManager.settings.characterAttackModifierDeckPermanent &&
        !settingsManager.settings.characterAttackModifierDeckActiveBottom) ||
      (settingsManager.settings.lootDeck && settingsManager.settings.applyLoot && character.lootCardsVisible),
    compact: compact,
    short: short,
    menu: shortMenu,
    fh: settingsManager.settings.theme === 'fh',
    modern: settingsManager.settings.theme === 'modern',
    'active-border': character.active && (settingsManager.settings.theme === 'modern' || compact)
  }"
>
  <ghs-entity-index-key [entity]="character"></ghs-entity-index-key>

  <ghs-character-image [character]="character"></ghs-character-image>

  @if (!character.absent) {
    <ghs-pointer-input
      class="drag-initiative"
      (dragMove)="gameManager.stateManager.characterPermissions[character.name + '|' + character.edition] && dragInitiativeMove($event)"
      (dragEnd)="gameManager.stateManager.characterPermissions[character.name + '|' + character.edition] && dragInitiativeEnd($event)"
      [draggingDisabled]="!settingsManager.settings.dragValuesInitiative"
      (singleClick)="toggleFigure($event)"
      (doubleClick)="
        gameManager.stateManager.characterPermissions[character.name + '|' + character.edition] && initiativeDoubleClick($event)
      "
      [ngClass]="{
        'outer-denied':
          gameManager.stateManager.permissions &&
          !gameManager.stateManager.permissions.round &&
          !gameManager.stateManager.characterPermissions[character.name + '|' + character.edition]
      }"
    >
    </ghs-pointer-input>
    @if (!short) {
      <ghs-character-initiative class="initiative" [figure]="character" [initiative]="initiative"></ghs-character-initiative>
    }
    <ghs-highlight-conditions [entity]="character" [figure]="character"></ghs-highlight-conditions>
    @if (
      (bb || settingsManager.settings.characterSheet) &&
      settingsManager.settings.characterAttackModifierDeck &&
      !settingsManager.settings.characterAttackModifierDeckPermanent &&
      !settingsManager.settings.characterAttackModifierDeckActiveBottom
    ) {
      <div class="attack-modifierdeck-container" [ngClass]="{ active: character.attackModifierDeckVisible }">
        <div class="scroll-container">
          <ghs-attackmodifier-deck
            [deck]="character.attackModifierDeck"
            [character]="character"
            (before)="beforeAttackModifierDeck($event)"
            (after)="afterAttackModifierDeck($event)"
          >
          </ghs-attackmodifier-deck>
        </div>
        <div class="attack-modifierdeck-close" (click)="toggleAttackModifierDeckVisible()"></div>
      </div>
    }
    @if (!bb && settingsManager.settings.lootDeck && character.lootCardsVisible) {
      <div class="loot-cards-container">
        <div class="scroll-container">
          <div class="loot-cards">
            @for (index of character.lootCards; track index) {
              <div class="loot-card" (click)="openLootDeckDialog()">
                <ghs-loot [loot]="gameManager.game.lootDeck.cards[index]" [flipped]="true" [disableFlip]="true"></ghs-loot>
              </div>
            }
          </div>
        </div>
        <div class="loot-cards-close" (click)="toggleLootCardsVisible()"></div>
      </div>
    }
  }

  <div class="stats">
    @if (!character.absent) {
      <div
        class="entity-menu-container"
        ghs-pointer-input
        (singleClick)="openEntityMenu()"
        (doubleClick)="compact && openCharacterSheet()"
      ></div>
      <div class="column col-1">
        <div
          class="entity-menu-container"
          ghs-pointer-input
          (singleClick)="openEntityMenu()"
          (doubleClick)="compact && openCharacterSheet()"
        ></div>
        @if (short) {
          <ghs-character-initiative class="initiative" [figure]="character" [initiative]="initiative"></ghs-character-initiative>
        }
        <div class="bar-container">
          <div
            class="entity-menu-container"
            ghs-pointer-input
            (singleClick)="openEntityMenu()"
            (doubleClick)="compact && openCharacterSheet()"
          ></div>
          <span class="title-bar">
            <span class="title" #characterName>
              <span
                class="icon"
                ghs-pointer-input
                (dragMove)="dragTokenMove($event)"
                (dragEnd)="dragTokenEnd()"
                (dragCancel)="dragCancel()"
                [relative]="true"
                [screenWidth]="true"
                (singleClick)="nextIdentity($event)"
              >
                <img
                  [ngClass]="{
                    identities: settingsManager.settings.characterIdentities && character.identities && character.identities.length > 1
                  }"
                  [src]="identityIcon ? identityIcon : character.iconUrl"
                />
              </span>
              @if (compact) {
                <ghs-character-initiative [figure]="character" [initiative]="initiative"></ghs-character-initiative>
              }
              <span class="name" ghs-pointer-input (singleClick)="openEntityMenu()" (doubleClick)="compact && openCharacterSheet()">
                {{ characterTitle }}
                @if (character.exhausted) {
                  <img class="ghs-svg exhausted" src="./assets/images/status/exhausted.svg" />
                }
              </span>
            </span>
            <span class="actions">
              @for (action of extraActions | trackUUID; track action._trackUUID; let i = $index) {
                <span class="action" ghs-pointer-input (singleClick)="openEntityMenu()" (doubleClick)="removeExtraAction(action)">
                  <ghs-action [action]="action" [style]="'fh'"></ghs-action>
                </span>
              }
              @for (persistentAction of extraActionsPersistent | trackUUID; track persistentAction._trackUUID; let i = $index) {
                <span
                  class="action"
                  ghs-pointer-input
                  (singleClick)="openEntityMenu()"
                  (doubleClick)="removeExtraAction(persistentAction, true)"
                >
                  <span class="action-overlay">
                    <span class="text-white" [ghs-label]="'%game.card.persistent%'"></span>
                  </span>
                  <ghs-action [action]="persistentAction" [style]="'fh'"></ghs-action>
                </span>
              }
            </span>
            <span class="token-container">
              @if (character.token + (character.primaryToken < 0 ? token : 0) > 0) {
                <span
                  class="token"
                  [ghs-label]="'%data.characterToken.' + character.name + '%'"
                  ghs-pointer-input
                  (dragMove)="dragTokenMove($event)"
                  (dragEnd)="dragTokenEnd()"
                  (dragCancel)="dragCancel()"
                  [relative]="true"
                  [screenWidth]="true"
                  (singleClick)="nextIdentity($event)"
                  >></span
                >
              }
              @if (character.token + (character.primaryToken < 0 ? token : 0) > 1) {
                <span class="token value">
                  <span>x{{ character.token + (character.primaryToken < 0 ? token : 0) }}</span>
                </span>
              }
              @for (addToken of character.tokens; track addToken; let i = $index) {
                @if (character.tokenValues[i] + (character.primaryToken === i ? token : 0) > 0) {
                  <span class="token" [ghs-label]="'%data.characterToken.' + character.name + '.' + addToken + '%'"></span>
                }
                @if (character.tokenValues[i] + (character.primaryToken === i ? token : 0) > 1) {
                  <span class="token value">
                    <span>x{{ character.tokenValues[i] + (character.primaryToken === i ? token : 0) }}</span></span
                  >
                }
              }
            </span>
          </span>
          <div class="status-bar">
            @if (!settingsManager.settings.hideCharacterHP) {
              <div
                class="health"
                [ghs-label]="'game.health'"
                [ghs-label-attribute]="'title'"
                ghs-pointer-input
                (dragMove)="dragHpMove($event)"
                (dragEnd)="dragHpEnd()"
                (dragCancel)="dragCancel()"
                [draggingDisabled]="!settingsManager.settings.dragValuesHp"
                [relative]="true"
                [screenWidth]="true"
                [fastShift]="true"
                (singleClick)="openEntityMenu()"
                (doubleClick)="toggleDamageHP()"
              >
                <img
                  [ngClass]="{ damage: settingsManager.settings.damageHP }"
                  [src]="'./assets/images/' + (settingsManager.settings.damageHP ? 'action/damage.svg' : 'status/health.svg')"
                />
                @if (!settingsManager.settings.damageHP) {
                  <span> {{ characterHp + health | ghsMinZero }}/{{ characterMaxHp }} </span>
                }
                @if (settingsManager.settings.damageHP) {
                  <span> {{ characterMaxHp }}/{{ characterMaxHp - (characterHp + health) | ghsMinZero }} </span>
                }
                <span
                  class="value-overlay"
                  [value-sign]="health"
                  [hideEmpty]="true"
                  [reverse]="settingsManager.settings.damageHP"
                  [container]="true"
                ></span>
              </div>
            }
            <div class="markers">
              @for (marker of character.markers; track marker) {
                <span class="marker" ghs-pointer-input (doubleClick)="removeMarker(marker)">
                  <img [src]="gameManager.characterManager.characterIcon(marker)" />
                </span>
              }
            </div>
            <div class="conditions">
              @for (entityCondition of activeConditions | trackUUID; track entityCondition._trackUUID; let index = $index) {
                <span
                  class="condition"
                  ghs-pointer-input
                  (doubleClick)="removeCondition(entityCondition)"
                  [ngClass]="{ fh: settingsManager.settings.fhStyle }"
                >
                  <img
                    [src]="
                      './assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + entityCondition.name + '.svg'
                    "
                    [style.z-index]="index * 10 + entityCondition.value"
                  />
                  @if (entityCondition.types.includes(ConditionType.stack)) {
                    @for (i of [] | ghsRange: entityCondition.value - 1; track i) {
                      <img
                        class="stack"
                        [style.z-index]="index * 10 + entityCondition.value - i - 1"
                        [src]="
                          './assets/images' +
                          (settingsManager.settings.fhStyle ? '/fh' : '') +
                          '/condition/' +
                          entityCondition.name +
                          '.svg'
                        "
                      />
                    }
                  }
                  @if (entityCondition.types.includes(ConditionType.value) && !entityCondition.types.includes(ConditionType.stack)) {
                    <span class="value" [style.z-index]="index * 10 + entityCondition.value + 1">{{ entityCondition.value }}</span>
                  }
                  @if (character.immunities.includes(entityCondition.name)) {
                    <span class="condition immunity condition-overlay" [style.z-index]="index * 10 + entityCondition.value + 2"></span>
                  }
                  @if (entityCondition.permanent) {
                    <span class="condition permanent condition-overlay" [style.z-index]="index * 10 + entityCondition.value + 3"></span>
                  }
                  @if (entityCondition.state === EntityConditionState.roundExpire) {
                    <span class="condition round condition-overlay" [style.z-index]="index * 10 + entityCondition.value + 4"></span>
                  }
                </span>
              }
            </div>
          </div>
        </div>
      </div>
    }

    @if (character.absent) {
      @if (character.absent) {
        <div class="absent-menu" ghs-pointer-input (singleClick)="openEntityMenu()" (doubleClick)="compact && openCharacterSheet()"></div>
      }
      <div class="title absent" #characterName>
        <span class="icon">
          <img [src]="character.iconUrl" />
        </span>
        {{ gameManager.characterManager.characterName(character, character.absent) }}
        @if (character.exhausted) {
          <img class="ghs-svg exhausted" src="./assets/images/status/exhausted.svg" />
        }
      </div>
    }

    <span class="spacer"></span>

    @if (!character.absent) {
      <span class="spacer" ghs-pointer-input (singleClick)="openEntityMenu()" (doubleClick)="compact && openCharacterSheet()"></span>
      @if (
        !bb &&
        settingsManager.settings.lootDeck &&
        !!character.lootCards &&
        character.lootCards.length > 0 &&
        !settingsManager.settings.hideCharacterLoot
      ) {
        <div
          class="loot-cards-button"
          ghs-pointer-input
          (singleClick)="toggleLootCardsVisible()"
          [ngClass]="{ disabled: character.lootCardsVisible }"
        >
          <img src="./assets/images/fh/loot-token.png" />
          <span class="badge">{{ character.lootCards.length }}</span>
        </div>
      }
      @if ((bb || settingsManager.settings.characterSheet) && settingsManager.settings.characterAttackModifierDeck) {
        <span
          class="attack-modifier-button"
          ghs-pointer-input
          (singleClick)="toggleAttackModifierDeckVisible()"
          [ghs-label]="'game.attackModifiers'"
          [ghs-label-attribute]="'title'"
          [ngClass]="{
            bb: bb,
            active: settingsManager.settings.characterAttackModifierDeckActiveBottom && character.attackModifierDeckVisible
          }"
        >
          <img src="./assets/images/attackmodifier/icon.png" />
        </span>
      }
      @if (
        ((bb && !settingsManager.settings.characterAttackModifierDeckActiveBottom) || (!bb && settingsManager.settings.characterSheet)) &&
        settingsManager.settings.characterAttackModifierDeck &&
        settingsManager.settings.characterAttackModifierAnimate &&
        !character.attackModifierDeckVisible &&
        ((!settingsManager.settings.characterAttackModifierDeckPermanentActive &&
          !settingsManager.settings.characterAttackModifierDeckActiveBottom) ||
          !character.active)
      ) {
        <span class="attack-modifier-draw" [ngClass]="{ drawing: amAnimationDrawing }" [ngClass]="{ bb: bb }">
          <ghs-attackmodifier-draw [character]="character" (drawing)="amAnimationDrawing = $event"></ghs-attackmodifier-draw>
        </span>
      }
      @if (
        !bb &&
        !!gameManager.game.scenario &&
        settingsManager.settings.battleGoals &&
        (gameManager.roundManager.firstRound ||
          settingsManager.settings.battleGoalsCharacter ||
          !settingsManager.settings.characterSheet ||
          !settingsManager.settings.characterAttackModifierDeck)
      ) {
        <div
          class="battlegoals-button"
          ghs-pointer-input
          (singleClick)="openBattleGoals()"
          [ghs-label]="'game.battleGoals'"
          [ghs-label-attribute]="'title'"
        >
          <img
            [src]="
              settingsManager.settings.fhStyle
                ? './assets/images/fh/battlegoals/battle-goal-back-fh.png'
                : './assets/images/battlegoals/battle-goal-back.png'
            "
          />
          @if (battleGoalSelected) {
            <img class="check" src="./assets/images/check.svg" />
          }
        </div>
      }
      @if (settingsManager.settings.characterItems) {
        <div
          class="items-button"
          ghs-pointer-input
          (singleClick)="openItems()"
          (doubleClick)="openItems(true)"
          [ghs-label]="'game.items'"
          [ghs-label-attribute]="'title'"
          [ngClass]="{ bb: bb }"
        >
          <img
            [src]="settingsManager.settings.fhStyle ? './assets/images/fh/items/item-back-fh.png' : './assets/images/items/item-back.png'"
          />
        </div>
      }
      @if (bb) {
        <div class="bb-spacer"></div>
      }
      @if (!bb && settingsManager.settings.summons) {
        <div class="summon-dialog">
          <div
            class="entity-menu-container"
            ghs-pointer-input
            (singleClick)="openEntityMenu()"
            (doubleClick)="compact && openCharacterSheet()"
          ></div>
          <a
            #summonButton
            class="summon-dialog-button"
            ghs-pointer-input
            (singleClick)="openSummonDialog()"
            [ghs-label]="'summon'"
            [ghs-label-attribute]="'title'"
          >
            <img class="ghs-svg" src="./assets/images/plus.svg" />
          </a>
        </div>
      }
      @if (compact && short) {
        <div class="short-menu">
          <div class="entity-menu-container" ghs-pointer-input (singleClick)="openEntityMenu()"></div>
          <a class="toggle-menu" ghs-pointer-input (singleClick)="shortMenu = !shortMenu">
            <img class="ghs-svg" src="./assets/images/menu.svg" />
          </a>
        </div>
      }
      <div class="column col-2">
        <div
          class="entity-menu-container"
          ghs-pointer-input
          (singleClick)="openEntityMenu()"
          (doubleClick)="compact && openCharacterSheet()"
        ></div>
        @if (!bb && !settingsManager.settings.hideCharacterXP) {
          <span
            class="experience"
            [ghs-label]="'game.experience'"
            [ghs-label-attribute]="'title'"
            ghs-pointer-input
            (singleClick)="addExperience(1)"
            (doubleClick)="addExperience(-1)"
            (dragMove)="dragXpMove($event)"
            (dragEnd)="dragXpEnd()"
            (dragCancel)="dragCancel()"
            [draggingDisabled]="!settingsManager.settings.dragValuesXp"
            [relative]="true"
            [screenWidth]="true"
          >
            {{ character.experience + experience }}
            <img src="./assets/images/status/experience.svg" />
            <span class="value-overlay" [value-sign]="experience" [hideEmpty]="true" [container]="true"></span>
          </span>
        }
        @if (
          !bb &&
          (!settingsManager.settings.lootDeck || (!settingsManager.settings.alwaysLootDeck && !gameManager.fhRules())) &&
          !settingsManager.settings.hideCharacterLoot
        ) {
          <span
            class="loot"
            [ghs-label]="'game.loot'"
            [ghs-label-attribute]="'title'"
            ghs-pointer-input
            (singleClick)="addLoot(1)"
            (doubleClick)="addLoot(-1)"
            (dragMove)="dragLootMove($event)"
            (dragEnd)="dragLootEnd()"
            (dragCancel)="dragCancel()"
            [draggingDisabled]="!settingsManager.settings.dragValuesLoot"
            [relative]="true"
            [screenWidth]="true"
          >
            {{ character.loot + loot }}
            <img src="./assets/images/status/loot.svg" />
            <span class="value-overlay" [value-sign]="loot" [hideEmpty]="true" [container]="true"></span>
          </span>
        }
      </div>
    }

    @if (!bb) {
      <a
        class="character-sheet-button"
        [ghs-label]="'character.progress'"
        [ghs-label-attribute]="'title'"
        [ngClass]="{ 'hand-size-margin': settingsManager.settings.characterHandSize }"
        ghs-pointer-input
        (singleClick)="settingsManager.settings.characterSheet ? openCharacterSheet() : openEntityMenu()"
        (doubleClick)="characterFullView()"
      >
        <img [src]="character.iconUrl" />
      </a>
    }

    @if (!character.bb && settingsManager.settings.characterHandSize && !character.absent) {
      <div class="hand-size" ghs-pointer-input (singleClick)="openEntityMenu()" (doubleClick)="openAbilityCards()">
        {{ character.handSize }}
      </div>
    }

    @if (character.bb && settingsManager.settings.characterHandSize && !character.absent) {
      <div class="hand-size">{{ character.level - 1 }}|4</div>
    }

    @if (settingsManager.settings.characterHandSize && !character.absent) {
      <div class="character-level">
        {{ character.level }}
      </div>
    }

    @if (!character.bb && settingsManager.settings.playerNumber) {
      <div class="player-number">#{{ character.number }}</div>
    }

    @if (settingsManager.settings.characterTraits && !character.absent && character.traits.length > 0) {
      <div class="character-traits" ghs-pointer-input (singleClick)="openEntityMenu()" (doubleClick)="compact && openCharacterSheet()">
        <span class="icon"><img class="ghs-svg" src="./assets/images/fh/character/traits/trait.svg" /></span>
        @for (trait of character.traits; track trait; let i = $index) {
          @if (i === 0) {
            <span class="divider"></span>
          }
          <span class="trait" [ghs-label]="'data.character.traits.' + trait"></span>
          @if (i < character.traits.length - 1) {
            <span class="divider">|</span>
          }
          @if (i === character.traits.length - 1) {
            <span class="divider"></span>
          }
        }
      </div>
    }

    @if (!!specialActions && specialActions.length > 0) {
      <div class="special-actions">
        <div
          class="entity-menu-container"
          ghs-pointer-input
          (singleClick)="openEntityMenu()"
          (doubleClick)="compact && openCharacterSheet()"
        ></div>
        @for (specialAction of specialActions | trackUUID; track specialAction._trackUUID; let i = $index) {
          <span
            class="special-tag text-white"
            [ghs-label]="'data.character.' + character.edition + '.' + character.name + '.' + specialAction.name"
            ghs-pointer-input
            (singleClick)="openEntityMenu()"
            (doubleClick)="removeSpecialAction(specialAction.name)"
            [ghs-tooltip]="'data.character.' + character.edition + '.' + character.name + '.' + specialAction.name + '.hint'"
            [originY]="'top'"
            [overlayY]="'bottom'"
            [originX]="'center'"
            [overlayX]="'center'"
          ></span>
          @if (!!specialAction.slots) {
            <span class="special-action-slots">
              @let current =
                specialAction.slots.length -
                character.tags.filter((tag) => tag === specialAction.name).length -
                (specialAction.slots[0].toLowerCase().includes('start') ? 0 : 1);

              @for (slot of specialAction.slots; track slot + i; let i = $index) {
                <span
                  class="special-action-slot"
                  [ngClass]="{ manual: specialAction.slotTrigger === 'manual' }"
                  ghs-pointer-input
                  (singleClick)="triggerSpecialActionSlot(specialAction, i)"
                  (doubleClick)="triggerSpecialActionSlot(specialAction, i, true)"
                >
                  <span class="slot" [ghs-label]="'%game.card.' + slot + '%'"></span>
                  <span
                    class="token"
                    [ngClass]="{ active: i === current }"
                    [ghs-label]="'%data.characterToken.' + character.name + '%'"
                  ></span>
                </span>
              }
            </span>
          }
          @if (i < specialActions.length - 1 && specialActions.length > 1) {
            <span class="separator">|</span>
          }
        }
      </div>
    }
  </div>

  <ghs-figure-errors [figure]="character"></ghs-figure-errors>
</div>

@if (!character.absent && settingsManager.settings.summons) {
  <div class="summons-container spirits" [ngClass]="{ empty: summonsAfterTurnCount === 0, off: off }">
    <span class="spacer"></span>
    @if (settingsManager.settings.entitiesMenu) {
      <span
        class="entities-menu"
        [ngClass]="{ empty: summonsAfterTurnCount === 0, disabled: summonsAfterTurnCount < 2 }"
        [entityAnimation]="summonsAfterTurnCount === 0"
        (click)="openEntitiesMenu($event)"
      >
        <img class="icon" [src]="character.iconUrl" />
        <img class="menu" src="./assets/images/up.svg" />
      </span>
    }
    @if (summonsAfterTurnCount) {
      <div class="summons">
        @for (summon of summonsAfterTurn | trackUUID; track summon._trackUUID) {
          <ghs-standee [ngClass]="{ active: summon.active }" [figure]="character" [entity]="summon"> </ghs-standee>
        }
      </div>
    }
  </div>
}

@if (
  settingsManager.settings.characterItems &&
  settingsManager.settings.characterItemsPermanent &&
  (character.itemsVisible ||
    (settingsManager.settings.characterItemsPermanentActive && character.active && character.progress.items.length > 0))
) {
  <div class="items-container-permanent">
    <ghs-character-item-list [character]="character"></ghs-character-item-list>
  </div>
}

@if (
  (bb || settingsManager.settings.characterSheet) &&
  settingsManager.settings.characterAttackModifierDeck &&
  settingsManager.settings.characterAttackModifierDeckPermanent &&
  !settingsManager.settings.characterAttackModifierDeckActiveBottom
) {
  <div
    class="attack-modifierdeck-container permanent"
    [ngClass]="{
      active:
        character.attackModifierDeckVisible || (settingsManager.settings.characterAttackModifierDeckPermanentActive && character.active)
    }"
  >
    <div class="scroll-container">
      <ghs-attackmodifier-deck
        [deck]="character.attackModifierDeck"
        [character]="character"
        (before)="beforeAttackModifierDeck($event)"
        (after)="afterAttackModifierDeck($event)"
      >
      </ghs-attackmodifier-deck>
    </div>
  </div>
}
